<app-default-layout>
  <div class="text-center">
    <h1 class="text-error">401</h1>
    <h3 class="mt-3 mb-2">Error de autenticación</h3>
    <p class="text-muted mb-3">{{errorMessage}}</p>
    <a routerLink="/" class="btn btn-primary waves-effect waves-light"><i class="mdi mdi-login"></i> Iniciar sesión</a>
  </div>
</app-default-layout>
